import Header from '@/pages/home/components/Header';
import Hero from '@/pages/home/components/Hero';
import MediaSection from '@/pages/home/components/MediaSection';
import CardsSection from '@/pages/home/components/CardsSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import IndexSection from '@/pages/home/components/IndexSection';
import AboutSection from '@/pages/home/components/AboutSection';
import AppSection from '@/pages/home/components/AppSection';
import FAQSection from '@/pages/home/components/FAQSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <MediaSection />

        <CardsSection />

        <TopicsSection />

        <IndexSection />

        <AboutSection />

        <AppSection />

        <FAQSection />

        <RankingSection />

        <FeaturesSection />

        <CommentsSection />

        <ContactSection />

        <CarouselSection />

        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}